<div class="w-full select-container"
  [ngClass]="variant === 'outlined' ? '' : 'min-w-[130px] max-w-[350px]'"
  #selectContainer>
  @if (!autoOpen && !hideTrigger) {
  <div class="flex items-center w-full cursor-pointer px-0 py-0 max-w-full transition-colors"
    [ngClass]="{
      'bg-gray-100 rounded-lg': variant === 'filled',
      'bg-gray-200': variant === 'filled' && isOpen(),
      'bg-white border border-soft-gray': variant === 'outlined' && !invalid,
      'bg-white border-2 border-negative': variant === 'outlined' && invalid
    }"
    [style.border-radius]="variant === 'outlined' ? '16px' : null"
    [style.height]="dropdownHeight" [attr.aria-disabled]="disabled"
    [class.opacity-50]="disabled" [class.cursor-not-allowed]="disabled" (click)="toggleDropdown($event)">
    <div
      class="flex-1 outline-none font-poppins bg-transparent truncate whitespace-nowrap overflow-hidden min-w-0 max-w-full"
      [ngClass]="{
        'text-text-primary': selectedOption?.label,
        'text-[#B6C2D3]': !selectedOption?.label && variant === 'outlined',
        'text-text-secondary': !selectedOption?.label && variant !== 'outlined',
        'font-medium': selectedOption?.label && variant === 'outlined',
        'font-normal': !selectedOption?.label && variant === 'outlined',
        'pl-4 text-sm leading-[20px]': variant === 'filled',
        'pl-4 text-base leading-6': variant === 'outlined'
      }"
      [style.font-size]="variant === 'outlined' ? null : (selectedOption?.label ? fontSize : placeholderFontSize)"
      [style.font-weight]="variant === 'outlined' ? null : (selectedOption?.label ? fontWeight : placeholderFontWeight)"
      [customTooltip]="selectedOption?.label || placeholder"
      [showOnlyWhenTruncated]="true">
      @if (multiSelect && getSelectedCount() > 0) {
        {{ getSelectedCount() }} seleccionado{{ getSelectedCount() > 1 ? 's' : '' }}
      } @else {
        {{ selectedOption?.label || placeholder }}
      }
    </div>
    @if (variant === 'outlined') {
      <i class="fi text-text-primary ml-2 transform transition-transform duration-200 flex items-center justify-center mr-4 pt-[2px]"
        [class.fi-rr-angle-down]="!isOpen()"
        [class.fi-rr-angle-up]="isOpen()"></i>
    } @else {
      <i class="fi fi-rs-angle-small-down text-text-primary text-[16px] ml-2 transform transition-transform duration-200 flex items-center justify-center mr-4"
        [class.rotate-180]="isOpen()"></i>
    }
  </div>
  }

  @if (isOpen()) {
  <div #panel
    class="absolute z-50 mt-1 w-full max-h-[212px] bg-white border border-soft-gray rounded-2xl animate-fadeIn flex flex-col shadow overflow-hidden"
    [ngClass]="variant === 'outlined' ? '' : 'min-w-[320px] max-w-[450px]'"
    style="visibility: hidden;"
    [style.visibility]="moved || !attachToBody ? 'visible' : 'hidden'">
    <div class="flex items-center w-full border-b border-gray-200 bg-white px-4 h-[46px] sticky top-0 z-10 overflow-hidden flex-shrink-0">
      <i
        class="fi fi-rr-search text-text-secondary leading-none text-[16px] flex items-center justify-center min-w-[16px] flex-shrink-0"></i>
      <input #searchInput [placeholder]="placeholder" type="text" [value]="searchTerm" (input)="onUserInput($event)"
        (click)="$event.stopPropagation()"
        class="flex-1 outline-none font-poppins font-medium text-text-primary placeholder-text-secondary bg-white focus:outline-none truncate whitespace-nowrap overflow-hidden min-w-0 ml-2"
        [style.font-size]="fontSize" [style.font-weight]="fontWeight" autocomplete="off" />
      @if (searchTerm) {
      <button type="button" class="ml-2 text-text-secondary hover:text-text-primary transition-colors flex-shrink-0"
        (click)="clearSearch(); $event.stopPropagation()" title="Limpiar búsqueda">
        <i class="fi fi-rr-cross-small text-[16px]"></i>
      </button>
      }
    </div>

    <ul class="overflow-y-auto overflow-x-hidden flex-1">
      @if (filteredOptions.length > 0) {
      @for (option of filteredOptions; track option.value) {
      @if (option.options && option.options.length > 0) {
      <!-- Grupo -->
      <li class="px-4 py-2">
        <p class="text-text-secondary font-poppins font-semibold text-xs uppercase truncate block overflow-hidden text-ellipsis whitespace-nowrap">
          {{ option.label }}
        </p>
        <ul class="mt-1">
          @for (subOption of option.options; track subOption.value) {
          <li
            class="group px-4 py-2 cursor-pointer overflow-hidden hover:bg-primary-g300 hover:text-white"
            [class.bg-primary-g300]="isOptionSelected(subOption)"
            [class.text-white]="isOptionSelected(subOption)"
            (click)="multiSelect ? toggleOptionSelection(subOption, $event) : selectOption(subOption, $event)">
            @if (multiSelect) {
              <!-- Modo multi-select con checkbox -->
              <app-checkbox 
                [labelPosition]="'left'" 
                [size]="'medium'" 
                [checked]="isOptionSelected(subOption)"
                [customClass]="'w-full'"
                [parentController]="true">
                <span label-left class="text-text-primary group-hover:text-white font-poppins text-base leading-6 truncate block overflow-hidden text-ellipsis whitespace-nowrap"
                  [class.font-semibold]="subOption.isStrong"
                  [class.font-medium]="isOptionSelected(subOption) && !subOption.isStrong"
                  [class.font-normal]="!isOptionSelected(subOption) && !subOption.isStrong"
                  [class.!text-white]="isOptionSelected(subOption)"
                  [customTooltip]="subOption.label"
                  [showOnlyWhenTruncated]="true">
                  {{ subOption.label }}
                </span>
              </app-checkbox>
            } @else {
              <!-- Modo selección simple -->
              <p class="text-text-primary group-hover:text-white font-poppins text-base leading-6 truncate block overflow-hidden text-ellipsis whitespace-nowrap"
                [class.font-semibold]="subOption.isStrong"
                [class.font-medium]="isOptionSelected(subOption) && !subOption.isStrong"
                [class.font-normal]="!isOptionSelected(subOption) && !subOption.isStrong"
                [class.!text-white]="isOptionSelected(subOption)"
                [customTooltip]="subOption.label"
                [showOnlyWhenTruncated]="true">
                {{ subOption.label }}
              </p>
            }
          </li>
          }
        </ul>
      </li>
      } @else {
      <!-- Opción simple -->
      <li
        class="group px-4 py-2 cursor-pointer overflow-hidden hover:bg-primary-g300 hover:text-white"
        [class.bg-primary-g300]="isOptionSelected(option)"
        [class.text-white]="isOptionSelected(option)"
        (click)="multiSelect ? toggleOptionSelection(option, $event) : selectOption(option, $event)">
        @if (multiSelect) {
          <!-- Modo multi-select con checkbox -->
          <app-checkbox 
            [labelPosition]="'left'" 
            [size]="'medium'" 
            [checked]="isOptionSelected(option)"
            [customClass]="'w-full'"
            [parentController]="true">
            <span label-left class="text-text-primary group-hover:text-white font-poppins text-base leading-6 truncate block overflow-hidden text-ellipsis whitespace-nowrap"
              [class.font-semibold]="option.isStrong"
              [class.font-medium]="isOptionSelected(option) && !option.isStrong"
              [class.font-normal]="!isOptionSelected(option) && !option.isStrong"
              [class.!text-white]="isOptionSelected(option)"
              [customTooltip]="option.label"
              [showOnlyWhenTruncated]="true">
              {{ option.label }}
            </span>
          </app-checkbox>
        } @else {
          <!-- Modo selección simple -->
          <p class="text-text-primary group-hover:text-white font-poppins text-base leading-6 truncate block overflow-hidden text-ellipsis whitespace-nowrap"
            [class.font-semibold]="option.isStrong"
            [class.font-medium]="isOptionSelected(option) && !option.isStrong"
            [class.font-normal]="!isOptionSelected(option) && !option.isStrong"
            [class.!text-white]="isOptionSelected(option)"
            [customTooltip]="option.label"
            [showOnlyWhenTruncated]="true">
            {{ option.label }}
          </p>
        }
      </li>
      }
      }
      } @else {
      @if (loading) {
      <li class="px-4 py-3 text-center">
        <div class="flex flex-col items-center justify-center gap-2">
          <div class="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-primary-g300"></div>
          <p class="text-sm text-text-secondary font-poppins font-normal">Cargando...</p>
        </div>
      </li>
      } @else {
      <li class="px-4 py-3 text-center">
        <p class="text-sm text-text-secondary font-poppins font-normal leading-5">
          No se encontraron<br />resultados
        </p>
      </li>
      }
      }
    </ul>
  </div>
  }
</div>